import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.trim.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0981ee11"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("小程序商品库");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("查看品种");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑品种");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("新增品种");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("返回");

const _hoisted_6 = {
  key: 0,
  style: {
    "margin-right": "10px"
  }
};

const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 选择商品 ");

const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 添加 ");

const _hoisted_9 = {
  style: {
    "width": "100%"
  }
};

const _hoisted_10 = /*#__PURE__*/_createTextVNode("启用");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("停用");

const _hoisted_12 = {
  class: "video-channel-list"
};
const _hoisted_13 = {
  class: "video-channel-item"
};

const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-channel-title"
}, "内嵌视频封面", -1));

const _hoisted_15 = {
  class: "video-channel-item"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-channel-title"
}, "内嵌视频", -1));

const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-channel-desc"
}, "仅支持 mp4，不超过 100MB", -1));

const _hoisted_18 = /*#__PURE__*/_createTextVNode("上传 mp4 视频");

const _hoisted_19 = {
  class: "video-channel-item"
};

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-channel-title"
}, "微信视频号", -1));

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-channel-desc"
}, "视频号 ID 与 feedId 需同时填写", -1));

const _hoisted_22 = {
  class: "video-channel-item"
};

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-channel-title"
}, "抖音", -1));

const _hoisted_24 = {
  class: "video-channel-item"
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-channel-title"
}, "B站", -1));

const _hoisted_26 = {
  class: "video-channel-item"
};

const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "video-channel-title"
}, "小红书", -1));

const _hoisted_28 = /*#__PURE__*/_createTextVNode("保存");

const _hoisted_29 = ["src"];
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { uploadFile, uploadVideoFile } from '@/request/api';
import { getVarietyDetail, getVarietyGoodsList, saveVariety } from '@/request';
import AddProductModal from '@/components/AddProductModal.vue';
export default {
  name: 'SaveVariety',

  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const form = ref({
      varietyId: null,
      goodsId: null,
      prodName: '',
      status: 1,
      advantageDesc: '',
      label: '',
      labelList: [],
      mainPicList: [],
      detailPicList: [],
      videoCoverList: [],
      videoFileList: [],
      wxFinderUserName: '',
      wxFeedId: '',
      innerVideoUrl: '',
      douyinUrl: '',
      bilibiliUrl: '',
      xhsUrl: ''
    });
    const formRef = ref();
    const isEdit = ref(false);
    const isSee = ref(false);
    const showAddProdModal = ref(false);
    const showImgModal = ref(false);
    const showImgUrl = ref('');
    const option = {
      name: 'file',
      action: uploadFile.url
    };
    const videoUploadOption = {
      name: 'file',
      action: uploadVideoFile.url
    };
    onMounted(() => {
      if (route.query.id) {
        isSee.value = !!route.query.isSee;
        isEdit.value = !route.query.isSee;
        getVarietyDetail({
          varietyId: route.query.id,
          __repeat: true,
          __warn: true
        }).then(data => {
          if (data.success) {
            var _data$data$status;

            form.value = _objectSpread(_objectSpread(_objectSpread({}, form.value), data.data), {}, {
              advantageDesc: data.data.advantageDesc || '',
              label: '',
              labelList: data.data.labelList || [],
              mainPicList: (data.data.mainPicList || []).map(i => ({
                name: Date.now(),
                url: i
              })),
              detailPicList: (data.data.detailPicList || []).map(i => ({
                name: Date.now(),
                url: i
              })),
              videoCoverList: data.data.innerVideoCover ? [{
                name: Date.now(),
                url: data.data.innerVideoCover
              }] : [],
              videoFileList: data.data.innerVideoUrl ? [{
                name: '产品介绍视频.mp4',
                url: data.data.innerVideoUrl
              }] : [],
              wxFinderUserName: data.data.wxFinderUserName || '',
              wxFeedId: data.data.wxFeedId || '',
              innerVideoUrl: data.data.innerVideoUrl || '',
              douyinUrl: data.data.douyinUrl || '',
              bilibiliUrl: data.data.bilibiliUrl || '',
              xhsUrl: data.data.xhsUrl || '',
              status: (_data$data$status = data.data.status) !== null && _data$data$status !== void 0 ? _data$data$status : 1
            });
          }
        });
      }
    });

    function validProd(goods) {
      if (goods.isExistVariety) {
        ElMessage.error('该商品已在品种库中，不可重复添加');
        return false;
      }

      return true;
    }

    function addGoods(goods) {
      form.value.goodsId = goods.goodsId;
      form.value.prodName = goods.prodName;
    }

    function noticePicBeforeUpload(file) {
      if (file.size / 1024 / 1024 > 1) {
        ElMessage.error('文件大小不可超过 1MB!');
        return false;
      }

      if (!/.(jp(e)?g|png)$/i.test(file.name)) {
        ElMessage.error('上传文件必须是 jpg,jpeg,png格式的文件');
        return false;
      }

      return true;
    }

    function videoBeforeUpload(file) {
      if (file.size / 1024 / 1024 > 100) {
        ElMessage.error('视频大小不可超过 100MB!');
        return false;
      }

      if (!/\.mp4$/i.test(file.name)) {
        ElMessage.error('仅支持 mp4 格式视频');
        return false;
      }

      return true;
    }

    function videoUploadSuccess(data) {
      if (data.code === 1) {
        form.value.innerVideoUrl = data.data.picUrl;
        form.value.videoFileList = form.value.videoFileList.map(file => {
          if (file.response) {
            file.url = file.response.data.picUrl;
            file.name = file.name || '产品介绍视频.mp4';
          }

          return file;
        });
        return;
      }

      ElMessage.error(data.msg || '视频上传失败');
      form.value.videoFileList = [];
    }

    function videoRemoveHandle() {
      form.value.innerVideoUrl = '';
      form.value.videoFileList = [];
    }

    function uploadSuccess(data, key) {
      if (data.code === 1) {
        form.value[key] = form.value[key].map(file => {
          if (file.response) {
            file.url = file.response.data.picUrl;
          }

          return file;
        });
        return;
      }

      ElMessage.error(data.msg || '上传失败');
    }

    function previewImg(file) {
      showImgUrl.value = file.url;
      showImgModal.value = true;
    }

    function delTag(index) {
      form.value.labelList.splice(index, 1);
    }

    function addTag() {
      if (!form.value.label) {
        ElMessage.error('添加标签不可为空!');
        return;
      }

      if (form.value.labelList.indexOf(form.value.label) > -1) {
        ElMessage.error('该标签已存在');
        return;
      }

      if (form.value.labelList.length >= 3) {
        ElMessage.error('标签最多只能添加3个!');
        return;
      }

      form.value.labelList.push(form.value.label);
      form.value.label = '';
    }

    function save() {
      formRef.value.validate(valid => {
        var _form$value$videoCove;

        if (!valid) {
          return;
        }

        if (!form.value.goodsId) {
          ElMessage.error('请选择万药城商品');
          return;
        }

        const wxFinderUserName = (form.value.wxFinderUserName || '').trim();
        const wxFeedId = (form.value.wxFeedId || '').trim();
        const hasWxFinder = !!wxFinderUserName;
        const hasWxFeed = !!wxFeedId;

        if (hasWxFinder !== hasWxFeed) {
          ElMessage.error('微信视频号需同时填写视频号ID和feedId');
          return;
        }

        if (hasWxFinder && !wxFinderUserName.startsWith('sph')) {
          ElMessage.error('微信视频号ID需以sph开头');
          return;
        }

        const payload = {
          varietyId: form.value.varietyId || undefined,
          goodsId: form.value.goodsId,
          prodName: form.value.prodName,
          status: form.value.status,
          advantageDesc: form.value.advantageDesc,
          labelList: form.value.labelList,
          mainPicList: form.value.mainPicList.map(i => i.url).filter(Boolean),
          detailPicList: form.value.detailPicList.map(i => i.url).filter(Boolean),
          innerVideoUrl: form.value.innerVideoUrl || '',
          innerVideoCover: ((_form$value$videoCove = form.value.videoCoverList[0]) === null || _form$value$videoCove === void 0 ? void 0 : _form$value$videoCove.url) || '',
          wxFinderUserName: hasWxFinder ? wxFinderUserName : '',
          wxFeedId: hasWxFeed ? wxFeedId : '',
          douyinUrl: (form.value.douyinUrl || '').trim(),
          bilibiliUrl: (form.value.bilibiliUrl || '').trim(),
          xhsUrl: (form.value.xhsUrl || '').trim()
        };
        saveVariety(payload).then(data => {
          if (data.success) {
            ElMessage.success('保存成功');
            router.back();
          }
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");

      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_alert = _resolveComponent("el-alert");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_tag = _resolveComponent("el-tag");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_Plus = _resolveComponent("Plus");

      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_upload = _resolveComponent("el-upload");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_breadcrumb, {
        separator: "/"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_breadcrumb_item, null, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), isSee.value ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 0
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })) : isEdit.value ? (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 1
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_breadcrumb_item, {
          key: 2
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }))]),
        _: 1
      }), _createVNode(_component_el_row, {
        style: {
          "margin-top": "20px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Back",
          type: "primary",
          link: "",
          onClick: _cache[0] || (_cache[0] = $event => _unref(router).back())
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_form, {
        model: form.value,
        ref_key: "formRef",
        ref: formRef,
        disabled: isSee.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "关联商品:",
          prop: "goodsId",
          rules: {
            required: true,
            message: '请选择万药城商品'
          }
        }, {
          default: _withCtx(() => [form.value.goodsId ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(form.value.prodName), 1)) : _createCommentVNode("", true), !isSee.value && !isEdit.value ? (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            type: "primary",
            onClick: _cache[1] || (_cache[1] = $event => showAddProdModal.value = true)
          }, {
            default: _withCtx(() => [_hoisted_7]),
            _: 1
          })) : _createCommentVNode("", true), !isEdit.value && !isSee.value ? (_openBlock(), _createBlock(_component_el_alert, {
            key: 2,
            type: "info",
            closable: false,
            style: {
              "margin-top": "8px"
            },
            title: "必须绑定万药城商品主数据；同一商品仅可创建一条品种"
          })) : _createCommentVNode("", true)]),
          _: 1
        }), form.value.prodName ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "品种名称:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: form.value.prodName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.prodName = $event),
            disabled: isSee.value || !isEdit.value,
            style: {
              "max-width": "400px"
            }
          }, null, 8, ["modelValue", "disabled"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "品种优势简述:",
          prop: "advantageDesc",
          rules: {
            required: true,
            message: '品种优势不可为空'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "textarea",
            autosize: {
              minRows: 4
            },
            modelValue: form.value.advantageDesc,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.advantageDesc = $event),
            maxlength: "300",
            placeholder: "产品简述，限制300字-此处讲述产品功效，市场容量，利润空间，市场接受度等",
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "招商标签:",
          prop: "labelList",
          rules: {
            required: true,
            message: '标签不可为空'
          }
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
            modelValue: form.value.label,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.label = $event),
            modelModifiers: {
              trim: true
            },
            placeholder: "5个字以内(实例: 独家)",
            maxlength: "5",
            style: {
              "width": "200px",
              "margin-right": "10px"
            },
            disabled: isSee.value
          }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_el_button, {
            type: "primary",
            onClick: addTag,
            disabled: form.value.labelList.length >= 3 || !form.value.label || isSee.value
          }, {
            default: _withCtx(() => [_hoisted_8]),
            _: 1
          }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.labelList, (item, index) => {
            return _openBlock(), _createBlock(_component_el_tag, {
              class: "tag",
              key: index,
              onClose: $event => delTag(index),
              closable: !isSee.value
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(item), 1)]),
              _: 2
            }, 1032, ["onClose", "closable"]);
          }), 128))])]),
          _: 1
        }), isEdit.value || isSee.value ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "状态:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: form.value.status,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.status = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              label: 1
            }, {
              default: _withCtx(() => [_hoisted_10]),
              _: 1
            }), _createVNode(_component_el_radio, {
              label: 0
            }, {
              default: _withCtx(() => [_hoisted_11]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
          label: "宣传主图:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            action: option.action,
            multiple: false,
            name: option.name,
            "before-upload": noticePicBeforeUpload,
            "on-preview": previewImg,
            "on-success": e => uploadSuccess(e, 'mainPicList'),
            "list-type": "picture-card",
            disabled: isSee.value,
            "file-list": form.value.mainPicList,
            "onUpdate:file-list": _cache[6] || (_cache[6] = $event => form.value.mainPicList = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_Plus)]),
              _: 1
            })]),
            _: 1
          }, 8, ["action", "name", "on-success", "disabled", "file-list"]), _createVNode(_component_el_alert, {
            type: "warning",
            closable: false,
            title: "建议尺寸 100*100，大小不超过 1MB，格式 png/jpg/jpeg；不上传则列表无本地主图"
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "详情介绍图:"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_upload, {
            action: option.action,
            multiple: true,
            name: option.name,
            "before-upload": noticePicBeforeUpload,
            "on-preview": previewImg,
            "on-success": e => uploadSuccess(e, 'detailPicList'),
            "list-type": "picture-card",
            disabled: isSee.value,
            "file-list": form.value.detailPicList,
            "onUpdate:file-list": _cache[7] || (_cache[7] = $event => form.value.detailPicList = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_Plus)]),
              _: 1
            })]),
            _: 1
          }, 8, ["action", "name", "on-success", "disabled", "file-list"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "视频讲解:"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_hoisted_14, _createVNode(_component_el_upload, {
            action: option.action,
            multiple: false,
            name: option.name,
            "before-upload": noticePicBeforeUpload,
            "on-preview": previewImg,
            "on-success": e => uploadSuccess(e, 'videoCoverList'),
            "list-type": "picture-card",
            disabled: isSee.value,
            limit: 1,
            "file-list": form.value.videoCoverList,
            "onUpdate:file-list": _cache[8] || (_cache[8] = $event => form.value.videoCoverList = $event)
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_Plus)]),
              _: 1
            })]),
            _: 1
          }, 8, ["action", "name", "on-success", "disabled", "file-list"])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _hoisted_17, _createVNode(_component_el_upload, {
            action: videoUploadOption.action,
            multiple: false,
            name: videoUploadOption.name,
            "before-upload": videoBeforeUpload,
            "on-success": videoUploadSuccess,
            "on-remove": videoRemoveHandle,
            limit: 1,
            accept: ".mp4,video/mp4",
            disabled: isSee.value,
            "file-list": form.value.videoFileList,
            "onUpdate:file-list": _cache[9] || (_cache[9] = $event => form.value.videoFileList = $event),
            style: {
              "margin-bottom": "10px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              disabled: isSee.value
            }, {
              default: _withCtx(() => [_hoisted_18]),
              _: 1
            }, 8, ["disabled"])]),
            _: 1
          }, 8, ["action", "name", "disabled", "file-list"]), _createVNode(_component_el_input, {
            modelValue: form.value.innerVideoUrl,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.innerVideoUrl = $event),
            placeholder: "上传后自动填充，也可手动粘贴 mp4 地址",
            disabled: isSee.value
          }, null, 8, ["modelValue", "disabled"])]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _hoisted_21, _createVNode(_component_el_input, {
            modelValue: form.value.wxFinderUserName,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.wxFinderUserName = $event),
            placeholder: "视频号 ID，sph 开头（选填）",
            style: {
              "margin-bottom": "10px"
            }
          }, null, 8, ["modelValue"]), _createVNode(_component_el_input, {
            modelValue: form.value.wxFeedId,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.wxFeedId = $event),
            placeholder: "视频 feedId（选填）"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createVNode(_component_el_input, {
            modelValue: form.value.douyinUrl,
            "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => form.value.douyinUrl = $event),
            placeholder: "抖音外链（选填）"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_24, [_hoisted_25, _createVNode(_component_el_input, {
            modelValue: form.value.bilibiliUrl,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => form.value.bilibiliUrl = $event),
            placeholder: "B站外链（选填）"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_26, [_hoisted_27, _createVNode(_component_el_input, {
            modelValue: form.value.xhsUrl,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => form.value.xhsUrl = $event),
            placeholder: "小红书外链（选填）"
          }, null, 8, ["modelValue"])])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "disabled"]), _createVNode(_component_el_row, {
        type: "flex",
        justify: "center"
      }, {
        default: _withCtx(() => [!isSee.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_28]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(AddProductModal, {
        beforeSuccess: validProd,
        queryApi: _unref(getVarietyGoodsList),
        modelValue: showAddProdModal.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => showAddProdModal.value = $event),
        onSuccess: addGoods
      }, null, 8, ["queryApi", "modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: showImgModal.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => showImgModal.value = $event),
        width: "600px"
      }, {
        default: _withCtx(() => [_createElementVNode("img", {
          src: showImgUrl.value,
          style: {
            "width": "100%"
          },
          alt: "Preview Image"
        }, null, 8, _hoisted_29)]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};